<template>
  <div></div>
</template>

<script>
export default {
  name: "routerStage",
  data() {
    return {
      indexName: "",
      // time1: new Date('2022-05-02 22:00:00').getTime(), // 第一阶段：72小时挑战
      time2: new Date("2022-05-02 17:00:00").getTime(), // 第二阶段：游戏投票开始时间
      time3: new Date("2022-05-09 00:00:00").getTime(), // 第三阶段：投票结果显示时间
      stageArr1: [
        "Index",
        "Register",
        "TrackType",
        "TrackComplete",
        "TrackCreative",
        "Success",
        "Home",
        "MRegister",
        "MTrackType",
        "MTrackComplete",
        "MTrackCreative",
        "MSuccess",
      ],
      stageArr2: ["Expect"],
      stageArr3: ["MVote", "Vote"],
      stageArr4: ["MFormula", "Formula"],
    };
  },
  created() {
    const THAT = this;
    THAT.indexName = THAT.$router.history.current.name;
  },
  mounted() {
    const THAT = this;
    // THAT.handleStage();
  },
  methods: {
    // handleStage() {
    //   const THAT = this;
    //   // console.log('🧑‍💻 => URL:', THAT.indexName);
    //   let currentTime = new Date().getTime();
    //   // console.log(THAT.stageArr1.indexOf(THAT.indexName), THAT.stageArr2.indexOf(THAT.indexName), THAT.stageArr3.indexOf(THAT.indexName), THAT.stageArr4.indexOf(THAT.indexName));
    //   // 第一阶段：72小时挑战
    //   if (currentTime < THAT.time2) {
    //     // console.log('🧑‍💻 => 第一阶段：72小时挑战');
    //     if (THAT.stageArr1.indexOf(THAT.indexName) == -1) {
    //       // console.log('不可访问页面');
    //       // location.replace('/72Hours/');
    //       THAT.$router.replace("/");
    //     }
    //     return false;
    //   }
    //   // 过度阶段：游戏审核阶段
    //   // if (currentTime > THAT.time1 && currentTime < THAT.time2) {
    //   //     console.log('🧑‍💻 => 过度阶段：游戏审核阶段');
    //   //     if (THAT.stageArr2.indexOf(THAT.indexName) == -1) {
    //   //         console.log('不可访问页面');
    //   //         THAT.$router.replace("/Expect");
    //   //     }
    //   //     return false;
    //   // }
    //   // 第二阶段：游戏投票
    //   if (currentTime >= THAT.time2 && currentTime < THAT.time3) {
    //     // console.log('🧑‍💻 => 第二阶段：游戏投票');
    //     if (THAT.stageArr3.indexOf(THAT.indexName) == -1) {
    //       // console.log('不可访问页面');
    //       THAT.$router.replace("/Vote");
    //     }
    //     return false;
    //   }
    //   // 第三阶段：投票结果
    //   if (currentTime >= THAT.time3) {
    //     // console.log('🧑‍💻 => 第三阶段：投票结果');
    //     if (THAT.stageArr4.indexOf(THAT.indexName) == -1) {
    //       // console.log('不可访问页面');
    //       THAT.$router.replace("/Formula");
    //     }
    //     return false;
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
.slide-down {
  position: fixed;
  left: 50%;
  bottom: 0;
  margin-left: -50px;
  z-index: 100;
  width: 100px;
  font-size: 58px;
  text-align: center;
  color: #2afcf5;
  transition: all 0.5s;
  animation: toDownAni 2s infinite linear;
}

@keyframes toDownAni {
  0% {
    transform: translateY(-200px);
    opacity: 0;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/plugin/routerStage.vue